import { render, staticRenderFns } from "./ActiveGateways.vue?vue&type=template&id=1f9100c2"
import script from "./ActiveGateways.vue?vue&type=script&lang=js"
export * from "./ActiveGateways.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports